export const FRESHDESK_RATING_VALUES = [1, 2, 3, 4, 5] as const;

export const MIN_FRESHDESK_RATING = FRESHDESK_RATING_VALUES[0];
export const MAX_FRESHDESK_RATING = FRESHDESK_RATING_VALUES[FRESHDESK_RATING_VALUES.length - 1];
